module.exports = __webpack_public_path__ + "media/images/icons/icon-email-7be30c9767d3945393998d94f497c570.svg";